export const fillTemplate = (template: string, data: object | null) => {
    if (!data) return template;
    return template.replace(/\{\{([^{}].+?)}}/g, (_: string, match: string) => (data as any)[match]);
};
